import axios from '@/plugins/axios'
import format from 'date-fns/format'
import subDays from 'date-fns/subDays'
import addDays from 'date-fns/addDays'

export default {
  namespaced: true,

  state: {
    loading: false,
    videos_loading: false,
    date_range: [
      format(subDays(new Date(), 7), 'yyyy-MM-dd'),
      format(addDays(new Date(), 1), 'yyyy-MM-dd')
    ],
    tracks: [],
    track_chart: [],
    videos: [],
    page: 1,
    page_size: 10,
    order_column: 'artist',
    order_type: 'asc',
    LineChartSett: {
      width: 'auto',
      height: 500,
      is3D: true,
      colors: ['#085178', '#e80021', '#1b9e77', '#2c67a5'],
      curveType: 'none',
      isStacked: 'relative',
      vAxis: {
        maxAlternation: 4,
        minorGridlines: {
          count: 15
        },
        minValue: 0,
        slantedText: true,
        slantedTextAngle: 70,
        gridlines: {
          count: 15
        },
        textStyle: {
          fontSize: 12
        },
        format: 'short',
        viewWindowMode: 'pretty'
      },
      hAxis: {
        format: 'short',
        viewWindowMode: 'pretty',
        textStyle: {
          fontSize: 13
        },
        color: '#FF0000'
      },
      tooltip: {
        textStyle: {
          color: '#000',
          fontSize: 16,
          isHtml: true
        },
        showColorCode: true
      },
      lineWidth: 2.3,
      legend: {
        position: 'bottom',
        textStyle: {
          color: '#303133',
          fontSize: 14,
          bold: true
        }
      },
      chartArea: {
        left: '15%',
        top: '5%',
        width: '100%',
        height: '70%'
      }
    }
  },

  mutations: {
    setTracks(state, payload) {
      state.tracks = payload
    },
    setTrackChart(state, payload) {
      state.track_chart = payload
    },
    setTrackVideos(state, payload) {
      state.videos = payload
    },
    setDateRange(state, payload) {
      state.date_range = [payload[0], payload[1]]
    },
    setPage(state, payload) {
      state.page = payload
    },
    setPageSize(state, payload) {
      state.page_size = payload
    },
    setOrdering(state, payload) {
      state.order_column = payload.column
      state.order_type = payload.type
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setVideosLoading(state, payload) {
      state.videos_loading = payload
    }
  },

  actions: {
    readTracks({ commit, state }, filters = null) {
      commit('setLoading', true)

      let ls = localStorage.getItem('track_report_filter')
      filters = JSON.parse(ls)

      axios.api
        .get('report/data/track', {
          params: {
            page: state.page,
            page_size: state.page_size,
            order_column: state.order_column,
            order_type: state.order_type,
            ...filters
          }
        })
        .then(r => {
          commit('setTracks', r.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },

    readTrackChart({ commit }, data) {
      console.log(data)
      axios.api
        .get(`report/data/track/${data.id}`, {
          params: {
            start: data.start,
            end: data.end,
            charts: true
          }
        })
        .then(r => {
          commit('setTrackChart', r.data.data)
          // commit('setLoading', false)
        })
        .catch(() => {
          // commit('setLoading', false)
        })
    },

    readTrackVideos({ commit }, id) {
      commit('setVideosLoading', true)
      axios.api
        .get(`report/data/track/${id}/video`)
        .then(r => {
          commit('setTrackVideos', r.data.data)
          commit('setVideosLoading', false)
        })
        .catch(() => {
          commit('setVideosLoading', false)
        })
    },

    exportCSV({ commit }, track) {
      axios.api
        .get(`report/data/track/${track.track}/video/csv`, {
          responseType: 'blob'
        })
        .then(r => {
          const url = window.URL.createObjectURL(new Blob([r.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute(
            'download',
            track.artist + '-' + track.title + '_videos.csv'
          )
          document.body.appendChild(link)
          link.click()
        })
        .catch(e => {
          console.log(e)
        })
    }
  },

  getters: {
    track_chart_views: state => {
      let result = [['Date', 'Views']]
      state.track_chart.map(s => {
        if (s[1] !== 'Views') {
          const date = new Date(s[0])
          result.push([date.toDateString().slice(3, 15), parseInt(s[1])])
        }
      })
      return result
    },
    track_chart_views_daily: state => {
      let result = [['Date', 'Daily']]
      state.track_chart.map(s => {
        if (s[2] !== 'Daily') {
          const date = new Date(s[0])
          result.push([date.toDateString().slice(3, 15), s[2]])
        }
      })
      return result
    },
    track_chart_previews: state => {
      let result = [['Date', 'Previews']]
      state.track_chart.map(s => {
        if (s[3] !== 'Previews') {
          const date = new Date(s[0])
          result.push([date.toDateString().slice(3, 15), s[3]])
        }
      })
      return result
    },
    track_chart_previews_daily: state => {
      let result = [['Date', 'Daily']]
      state.track_chart.map(s => {
        if (s[4] !== 'Daily Previews') {
          const date = new Date(s[0])
          result.push([date.toDateString().slice(3, 15), s[4]])
        }
      })
      return result
    },
    track_chart_downloads: state => {
      let result = [['Date', 'Downloads']]
      state.track_chart.map(s => {
        if (s[5] !== 'Downloads') {
          const date = new Date(s[0])
          result.push([date.toDateString().slice(3, 15), s[5]])
        }
      })
      return result
    },
    track_chart_downloads_daily: state => {
      let result = [['Date', 'Daily Downloads']]
      state.track_chart.map(s => {
        if (s[6] !== 'Daily Downloads') {
          const date = new Date(s[0])
          result.push([date.toDateString().slice(3, 15), s[6]])
        }
      })
      return result
    },
    track_chart_subscribers: state => {
      let result = [['Date', 'Subscribers']]
      state.track_chart.map(s => {
        if (s[7] !== 'Subscribers') {
          const date = new Date(s[0])
          result.push([date.toDateString().slice(3, 15), s[7]])
        }
      })
      return result
    },
    track_chart_subscribers_daily: state => {
      let result = [['Date', 'Daily']]
      state.track_chart.map(s => {
        if (s[8] !== 'Daily Subscribers') {
          const date = new Date(s[0])
          result.push([date.toDateString().slice(3, 15), s[8]])
        }
      })
      return result
    },
    top_5_tracks: state => {
      let result = []
      state.tracks.sort(function(a, b) {
        return parseFloat(b.video_count) - parseFloat(a.video_count)
      })
      result = state.tracks.slice(0, 5)
      return result
    }
  }
}
